<i18n>
{
	"en": {
		"noSubjectMessage": "You have unsaved changes. Do you want to save?",
		"messageWithSubject": "You have changed {subject}. Do you want to save?"
	},
	"no": {
		"noSubjectMessage": "Dine endringer er ikke lagret. Ønsker du å lagre?",
		"messageWithSubject": "Du har endret på {subject}. Ønsker du å lagre?"
	}
}
</i18n>

<template>
	<ConfirmCancelDialog
		v-bind="$attrs"
		:message="subject ?
			this.$t('messageWithSubject', { subject }) :
			this.$t('noSubjectMessage')"
		v-on="$listeners /* forwards all events */"
		@yes="$emit('save')"
		@no="$emit('close')"
	/>
</template>

<script>
import ConfirmCancelDialog from './ConfirmCancelDialog.vue';

export default {
	name: 'ConfirmUnsavedChanges',
	components: {
		ConfirmCancelDialog,
	},
	inheritAttrs: false,
	props: {
		subject: {
			type: String,
			default: null,
		},
	},
};
</script>
